import { IOutboxStore } from "@home-health-notify/domain";

export const outboxStore: IOutboxStore = {
  async getItem(key: string) {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  async setItem(key: string, value: string) {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Private-mode or quota-exceeded: sending still works, it just stops
      // surviving a reload.
    }
  },
  async removeItem(key: string) {
    try {
      localStorage.removeItem(key);
    } catch {
      // Nothing recoverable to do; a stale record is pruned by TTL anyway.
    }
  },
};
